// extracted by mini-css-extract-plugin
export default {"SpoofedCommitWarningBanner":"SpoofedCommitWarning-module__SpoofedCommitWarningBanner--EICDj"};